module.exports = __webpack_public_path__ + "static/img/Greg-Alexander.52110dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Greg-Alexander.jpg
// module id = /tJq
// module chunks = 0